import {Component, Input, ChangeDetectionStrategy} from "@angular/core";
import {NgClass} from "@angular/common";

@Component({
	selector: 'app-spinner',
	standalone: true,
	imports: [NgClass],
	template: `
		<div class="spinner" [style.scale]="scale">
			<div [ngClass]="color"></div>
			<div [ngClass]="color"></div>
			<div [ngClass]="color"></div>
			<div [ngClass]="color"></div>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
	@Input() color: 'accent' | 'secondary' | 'white' | 'grey' | 'primary' = 'white'
	@Input() scale = 1
}
